import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from 'react-hot-toast';
import { LoadingDots } from "../Components/LoadingDots";
import accountService from "../Services/accountService";
import customerService from "../Services/customerService";
import { FaArrowLeft } from "react-icons/fa6";
import moment from "moment";
import orderService from "../Services/orderService";

const AddOldOrder = () => {
    const navigate = useNavigate();
    const [responseError, setResponseError] = useState('');
    const [accounts, setAccounts] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isCustomerDropdownOpen, setCustomerDropdownOpen] = useState(false)

    const [data, setData] = useState({
        customer: "",
        amount: "",
        vat_amount: "",
        tracking_number: "",
        paid_amount: "0",
        payment_status: "notpaid",
        status: "deliveredorders",
        order_type: "B2B",
        order_date: "",
        reference_no: "",
        invoice: "",
        created_at: moment().format("YYYY-MM-DD")
    });

    const [errors, setErrors] = useState({});

    useEffect(() => {
        customerService.fetchAll().then((res) => {
            setCustomers(res.customers);
        });
        accountService.fetchAllActiveAccounts().then((res) => {
            setAccounts(res.accounts);
        });
    }, []);

    useEffect(() => {
        const randomInvoice = `DBS-${Math.floor(100000 + Math.random() * 900000)}`;
        const randomTracking = `D-TR-${Math.floor(10000000 + Math.random() * 90000000)}`;
        setData(prev => ({
            ...prev,
            invoice: randomInvoice,
            tracking_number: randomTracking,
        }));
     }, []);


    const handleChange = (v, n) => {
        if (n === 'order_date' && v > moment().format("YYYY-MM-DD")) {
            toast.error('Cannot select future date', { id: "1" });
            return;
        }
        setResponseError('');
        setData(d => ({ ...d, [n]: v }));
        if (v.length > 0) {
            setErrors(prev => ({ ...prev, [n]: false }));
        }
    };

    const handleSubmit = () => {
        let hasError = false;
        Object.keys(data).forEach(v => {
            if (!data[v] && !['paid_amount', 'payment_status', 'status', 'order_type', 'created_at'].includes(v)) {
                setErrors(prev => ({ ...prev, [v]: true }));
                hasError = true;
            }
        });

        if (hasError) {
            toast.error('Please fill the form correctly', { id: "1" });
        } else {
            setLoading(true);
            orderService.submitOldOrder(data)
            console.log("Submitting:", data);
            setTimeout(() => {
                setLoading(false);
                toast.success('Order Added Successfully', { id: "2" });
                navigate('/incomes');
            }, 1000);
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') handleSubmit();
    };

    return (
        <main className='mx-16 my-10 bg-gray-50 rounded-lg border py-8 px-20'>
            <h1 className='text-center font-bold text-2xl text-gray-700 uppercase'>Add Old Order</h1>

            <div className="mt-10">
                <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-8">
                    <div className="col-span-2">
                        <label className="primary-label">Customer</label>
                        <div className="relative w-full bg-white">
                            <button
                                type="button"
                                className={`flex justify-between items-center border px-3 py-2 rounded-lg w-full focus:outline-none hover:border-gray-500 focus:border-gray-400 hover:border-opacity-50 border-gray-200 ${
                                errors['customer'] ? '!border-red-600' : ''
                                }`}
                                onClick={() => setCustomerDropdownOpen(!isCustomerDropdownOpen)}
                            >
                                <span className={`${data.customer ? 'text-gray-800' : 'text-gray-400'} text-left truncate`}>
                                {data.customer
                                    ? customers.find(c => c.id === data.customer)?.company_name
                                    : 'Select Customer'}
                                </span>
                                <svg
                                className={`fill-current h-4 w-4 ml-2 transition-transform duration-300 ${
                                    isCustomerDropdownOpen ? 'rotate-180' : ''
                                }`}
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                                >
                                <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" />
                                </svg>
                            </button>

                            <ul
                                className={`absolute z-10 mt-1 w-full bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-auto transition-all duration-200 ${
                                isCustomerDropdownOpen ? 'block' : 'hidden'
                                }`}
                            >
                                {customers.length > 0 ? (
                                customers.map((customer) => (
                                    <li
                                    key={customer.id}
                                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer w-full"
                                    onClick={() => {
                                        handleChange(customer.id, 'customer');
                                        setCustomerDropdownOpen(false);
                                    }}
                                    >
                                    {customer.company_name}
                                    </li>
                                ))
                                ) : (
                                <li className="px-4 py-2 text-gray-400">No customers available</li>
                                )}
                            </ul>
                         </div>
                    </div>
                    <div>
                        <label className="primary-label">Amount</label>
                        <input
                            name="amount"
                            type="number"
                            value={data.amount}
                            onChange={handleChange}
                            placeholder="Enter Amount"
                            className={`primary-input ${errors['amount'] ? "!border-red-600" : ""}`}
                        />
                    </div>
                </div>
                <div className="grid grid-cols-2 gap-2 md:grid-cols-3 md:gap-8 mt-4">
                    <div>
                        <label className="primary-label">VAT Amount</label>
                        <input
                            name="vat_amount"
                            type="number"
                            value={data.vat_amount}
                            onChange={handleChange}
                            placeholder="Enter VAT Amount"
                            className={`primary-input ${errors['vat_amount'] ? "!border-red-600" : ""}`}
                        />
                    </div>
                    <div>
                        <label className="primary-label">Reference No</label>
                        <input
                            name="reference_no"
                            type="text"
                            value={data.reference_no}
                            onChange={handleChange}
                            placeholder="Enter Reference No"
                            className={`primary-input ${errors['reference_no'] ? "!border-red-600" : ""}`}
                        />
                    </div>
                    <div>
                        <label className="primary-label">Order Date</label>
                        <input
                            name="order_date"
                            type="date"
                            value={data.order_date}
                            onChange={handleChange}
                            placeholder="Enter Order Date"
                            className={`primary-input ${errors['order_date'] ? "!border-red-600" : ""}`}
                        />
                    </div>
                </div>
                <div className="flex items-center justify-center flex-col mt-12">
                    <button
                        onClick={handleSubmit}
                        className={`button-primary ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                        disabled={loading}
                    >
                        Add
                        {loading ? <LoadingDots /> : ""}
                    </button>
                </div>
            </div>
        </main>
    );
};

export default AddOldOrder;
